"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletBalanceBucket = void 0;
var WalletBalanceBucket;
(function (WalletBalanceBucket) {
    WalletBalanceBucket["Spendable"] = "Spendable";
    WalletBalanceBucket["ShieldBlocked"] = "ShieldBlocked";
    WalletBalanceBucket["ShieldPending"] = "ShieldPending";
    WalletBalanceBucket["ProofSubmitted"] = "ProofSubmitted";
    WalletBalanceBucket["MissingInternalPOI"] = "MissingInternalPOI";
    WalletBalanceBucket["MissingExternalPOI"] = "MissingExternalPOI";
    WalletBalanceBucket["Spent"] = "Spent";
})(WalletBalanceBucket || (exports.WalletBalanceBucket = WalletBalanceBucket = {}));
